import * as React from 'react';
import './Loading.css';

const Loading = (props: any) => {
  return (
    <div>
      <span className="progress_circle small rotating" /> loading...
    </div>
  );
}

export default Loading


// WEBPACK FOOTER //
// ./src/modules/shared/components/loading/Loading.tsx